<template>
  <div>
    <ranch-button
      v-if="hideEstimationForm"
      @click="priority = null"
      icon="chevron-left"
      class="bg-gray-100"
      action=""
      :label="i18n.estimation.adjust_estimation"
    ></ranch-button>
    <slot name="goback" v-else />
    <div class="overflow-x-hidden text-sm">
      <div
        class="flex transform duration-500 -ease-in-out transition-transform"
        :class="{ '-translate-x-1/2': hideEstimationForm }"
      >
        <div class="w-1/2 flex-shrink-0">
          <h2
            class="text-center w-full font-bold pb-5 text-xl"
            v-text="i18n.estimation.title"
          />
          <estimation-form
            :farms="farms"
            :i18n="i18n.estimation"
            v-model="estimationForm"
          />
        </div>
        <transition>
          <div class="w-1/2 flex-shrink-0">
            <h2
              v-if="estimationForm"
              class="text-center w-full font-bold pb-5 text-xl"
              v-text="i18n.estimation.estimation"
            />
            <estimation-result
              v-if="estimationForm"
              :seconds="estimationForm.seconds"
              :images="estimationForm.images"
              :score="estimationForm.score"
              :renderer="renderer"
              :i18n="i18n.estimation"
              :selected-priority="priority"
              @priority-selected="prioritySelected"
            ></estimation-result>
          </div>
        </transition>
        <div
          class="w-1/2 flex-shrink-0 p-2 transform duration-500 -ease-in-out transition-transform bg-full-white"
          :class="{ '-translate-x-full': !isEstimable }"
        >
          <h2
            class="text-center w-full font-bold pb-5 text-xl"
            v-text="i18n.submit.title"
          />
          <parameters
            :application-slug="applicationSlug"
            :renderer="renderer"
            :priority="priority"
            :i18n="i18n.submit.form"
            :missing-frames="missingFrames"
            @project-created="$emit('project-created', $event)"
          ></parameters>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EstimationForm from "./EstimationForm.vue";
import EstimationResult from "./EstimationResult.vue";
import Parameters from "../Parameters/Parameters";
export default {
  components: { EstimationForm, EstimationResult, Parameters },
  props: ["renderer", "i18n", "applicationSlug", "missingFrames"],
  data() {
    return {
      estimationForm: null,
      priority: null,
    };
  },
  computed: {
    isEstimable() {
      return this.estimationForm;
    },
    hideEstimationForm() {
      return this.isEstimable && this.priority;
    },
    farms() {
      return this.renderer.farms;
    },
  },
  methods: {
    prioritySelected(priority) {
      if (this.priority && this.priority.id == priority.id) {
        this.priority = null;
      } else {
        this.priority = priority;
      }
    },
  },
};
</script>
